import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SEO } from "@/components/common/SEO";
import { Loader2 } from "lucide-react";
import CarCard from "@/components/common/CarCard";

export default function BrandDetail() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setData(null); setErr(false);
    api.get(`/brands/${slug}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <div className="max-w-md mx-auto py-20 text-center" data-testid="brand-not-found">
    <div className="font-display text-3xl">Brand not found</div>
    <Link to="/brands" className="text-blue-600 mt-4 inline-block">← Back to all brands</Link>
  </div>;
  if (!data) return <div className="grid place-items-center py-24 text-muted-foreground"><Loader2 className="w-6 h-6 animate-spin"/></div>;

  const { brand, cars } = data;
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12" data-testid={`brand-page-${brand.slug}`}>
      <SEO
        title={brand.meta_title || `${brand.name} Cars in India`}
        description={brand.meta_description || brand.description || `Explore all ${brand.name} cars in India — prices, specs, mileage and reviews.`}
        image={brand.logo_url}
      />
      <div className="mb-10">
        <Link to="/brands" className="text-sm text-blue-600 hover:underline">← All brands</Link>
        <div className="mt-4 flex items-center gap-4">
          {brand.logo_url && <img src={brand.logo_url} alt={brand.name} className="w-16 h-16 object-contain rounded-2xl bg-[#F3F6FA] border border-[#E5E7EB]"/>}
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{brand.country}</div>
            <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">{brand.name}</h1>
          </div>
        </div>
        {brand.description && <p className="mt-4 text-muted-foreground max-w-2xl">{brand.description}</p>}
      </div>

      <div className="mb-6 text-sm text-muted-foreground">{cars.length} model{cars.length === 1 ? "" : "s"}</div>
      {cars.length === 0 ? (
        <div className="text-muted-foreground text-sm">No cars listed for this brand yet.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cars.map((c) => <CarCard key={c.slug} car={c}/>)}
        </div>
      )}
    </div>
  );
}
